exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntemplate[data-v-163bbdeb], body[data-v-163bbdeb] {\n\theight: calc(100vh - 52px);\n\tmargin: 0;\n\tdisplay: flex;\n}\n.half-screen[data-v-163bbdeb] {\n\theight: 100%;\n\twidth:50%;\n\toverflow-y: auto;\n\tpadding: 5px;\n\tborder: 1px solid gray;\n\tposition: relative;\n\tbox-sizing: border-box;\n}\ntable[data-v-163bbdeb] {\n\twidth: 100%;\n\tborder-collapse: collapse;\n}\nth[data-v-163bbdeb], td[data-v-163bbdeb] {\n\tpadding: 4px;\n\ttext-align: left;\n\tborder: 1px solid #bbb;\n}\n.selected[data-v-163bbdeb] {\n\tbackground-color: #ddd;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-163bbdeb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/edit/Edit_Website.vue
// module id = 711
// module chunks = 0